/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import PropTypes from 'prop-types'
import {Stack, ListItem, UnorderedList, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {
    DiscountIcon,
    FavouriteIcon,
    ManualsIcon,
    SearchIcon,
    CartIcon,
    SupportIcon,
    FiltersIcon,
    Icon360,
} from '../../../components/icons'

const RegisterForm = ({isThankYouPage = false}) => {
    const stylesLogin = useMultiStyleConfig('Login')

    return (
        <Stack {...stylesLogin.registrationBenefits}>
            <UnorderedList {...stylesLogin.registrationList}>
                {isThankYouPage ? (
                    <>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <CartIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    id="registration_benefits.thank_you.products_suggestions"
                                    defaultMessage="Products suggestions"
                                />
                            </Text>
                        </ListItem>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <SupportIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    id="registration_benefits.thank_you.easy_assistance"
                                    defaultMessage="Easy assistance"
                                />
                            </Text>
                        </ListItem>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <FavouriteIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    id="registration_benefits.thank_you.news_and_special_offers"
                                    defaultMessage="News and special offers"
                                />
                            </Text>
                        </ListItem>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <FiltersIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    id="registration_benefits.thank_you.registered_products_history"
                                    defaultMessage="Registered products history"
                                />
                            </Text>
                        </ListItem>
                    </>
                ) : (
                    <>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <SearchIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <strong>
                                    <FormattedMessage
                                        defaultMessage="Track your orders"
                                        id="login_form.message.registration_track_orders"
                                    />
                                </strong>
                                <FormattedMessage
                                    defaultMessage="and see your full order history"
                                    id="login_form.message.registration_track_orders2"
                                />
                            </Text>
                        </ListItem>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <DiscountIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    defaultMessage="Get"
                                    id="login_form.message.registration_get_discounts"
                                />
                                <strong>
                                    <FormattedMessage
                                        defaultMessage="discounts"
                                        id="login_form.message.registration_get_discounts2"
                                    />
                                </strong>
                                <FormattedMessage
                                    defaultMessage="and"
                                    id="login_form.message.registration_get_discounts3"
                                />
                                <strong>
                                    <FormattedMessage
                                        defaultMessage="special offers"
                                        id="login_form.message.registration_get_discounts4"
                                    />
                                </strong>
                            </Text>
                        </ListItem>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <FavouriteIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    id="product_registration_confirm.save_favourites"
                                    defaultMessage="Save your favourite products"
                                />
                            </Text>
                        </ListItem>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <ManualsIcon {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    id="product_registration.icon360_description"
                                    defaultMessage="Easy access to your product information and helpful tips"
                                />
                            </Text>
                        </ListItem>
                        <ListItem {...stylesLogin.registrationListItem}>
                            <Icon360 {...stylesLogin.registrationIcons} />
                            <Text {...stylesLogin.registrationListText}>
                                <FormattedMessage
                                    id="product_registration_confirm.access_websites"
                                    defaultMessage="Access all De'Longhi Group websites with the same account"
                                />
                            </Text>
                        </ListItem>
                    </>
                )}
            </UnorderedList>
        </Stack>
    )
}

RegisterForm.propTypes = {
    isThankYouPage: PropTypes.bool,
}

export default RegisterForm
